export const STATUS_IN_PROGRESS = {
  color: 'warning',
  text: 'Em andamento',
  value: 'A',
}

export const STATUS_CANCELLED = {
  color: 'error',
  text: 'Cancelado',
  value: 'C',
}

export const STATUS_FINISHED = {
  color: 'success',
  text: 'Finalizado',
  value: 'F',
}
export const STATUS_UNKNOWN = {
  color: 'default',
  text: 'Outro',
}
export const ERROR_MSGS = {
  duplicate: 'Já existe um atendimento em andamento para a patologia selecionada!',
}
export const STATUS_MAP = [STATUS_IN_PROGRESS, STATUS_CANCELLED, STATUS_FINISHED].reduce(
  (acc, status) => ({ ...acc, [status.value]: status }),
  {},
)

export const DOCUMENT_PHOTO = 'FOTO_PACIENTE'
export const DOCUMENT_EXAM = 'EXAME'
